export default __webpack_public_path__ + "static/media/port-grey.55dbab75.svg";